import { Field, getIn } from 'formik';
import React, { ReactElement, useMemo } from 'react';
import { CHARCOAL_GREY } from '~/Constants/Colors.constants';
import { ISelectOptions } from '~/Models/interfaces/SelectOption.models';
import { useItemCreationContext } from '~/ModularComponents/ItemCreation/ItemCreation';
import { MenuItem, TextField } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';

interface IInputSelectProps<T> {
  name: keyof T;
  icon?: ReactElement;
  label: string;
  placeholder?: string;
  options?: ISelectOptions;
}

const useStyles = makeStyles(
  {
    container: {
      color: CHARCOAL_GREY,
      width: '100%',
    },
  },
  { name: 'inputSelect' },
);

export const InputSelect = <T extends object>({
  name,
  icon,
  label,
  placeholder,
  options,
}: IInputSelectProps<T>) => {
  const { isLoading, disabled, values, errors } = useItemCreationContext();
  const { classes } = useStyles();

  const value = getIn(values, name as string);
  const isDisabled = getIn(disabled, name as string);
  const error = getIn(errors, name as string);

  return useMemo(
    () => (
      <Field
        className={classes.container}
        component={TextField}
        fullWidth
        name={name}
        value={value || ''}
        placeholder={placeholder || label}
        label={label}
        newDesign
        icon={icon}
        disabled={isDisabled || isLoading}
        select
      >
        {options?.map((option, index) => (
          <MenuItem value={option.value} key={`${String(name)}_${index}`}>
            {option.label}
          </MenuItem>
        ))}
      </Field>
    ),
    [value, isDisabled, isLoading, error, icon, options],
  );
};
